function showModal(text) {
	
	var modalMarkup = '<div class="js-loading-modal LoadingModal">\
						<img src="' + window.location.origin + '/wp-content/themes/mintmobile/images/mint-fox-anim.gif" class="LoadingModal-animation">\
						<div class="LoadingModal-content">\
							<p>' + text + '</p>\
						</div>\
					</div>';

	$('body').append(modalMarkup);
}

function removeModal() {
	$('.js-loading-modal').remove();
}

export default {
	show: showModal,
	remove: removeModal
}